export const COLLAB_SENIOR_MANAGEMENT_VIEW = 'COLLAB_SENIOR_MANAGEMENT_VIEW';
